"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyMessage = void 0;
const DataSignalingInterfaces_1 = require("./DataSignalingInterfaces");
exports.EmptyMessage = {
    nucleusDataType: DataSignalingInterfaces_1.DataMessages.TYPE_MESSAGE,
    deviceId: "",
    id: "",
    message: "",
    deliveryTimeUtc: "",
    deliveryTime: "",
    messageDelivered: false,
    messageRead: false,
    isExpired: false,
    isPersistent: false,
    ttlHours: 0,
    ttlMinutes: 0,
    dingRepeatInMin: 0,
    devicesProcessedForDelivery: [],
    category: "",
    icon: "",
    enableVoiceMessage: false,
    voiceMessageCreated: false,
    messageId: "",
    soundEffect: "",
    ThumbnailUrl: "",
    ThumbImageTitle: "",
    isSingleOptionMessage: false,
    isMultipleOptionMessage: false,
    isLinkMessage: false,
    linkMessageUrl: "",
    linkMessageShouldOpen: false,
    linkMessageButton: "",
    isSignatureMessage: false,
    pdfFileUrl: "",
    templateType: "",
    biometricTypeTag: "",
    sender: "",
    updatedDate: "",
    options: []
};
